import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import ReactECharts from 'echarts-for-react';

import Bs4GenericField from './Bs4GenericField';

export default class Bs4Wykres extends Bs4GenericField {

  hesValue () {return false;}
  
  ViewComponentField = (props) => {
    const formField = this;
    const [showView, setShowView] = React.useState(false)
    this.refFocus = React.useRef(null);

    React.useLayoutEffect(() => {
      //if (!props.field.bs4echart || Array.isArray(props.field.bs4echart)) return;
      new ResizeObserver((entries, observe) => {       
        //if (refDiv.current.clientHeight === 0) refDiv.current.style.height = '555px';
        //if (refDiv.current.clientWidth === 0) refDiv.current.style.width = '555px';      
        setShowView(true)
        observe.disconnect();
      }).observe(this.refFocus.current);      
    }, [])    

    const style = this.props.field?.height ? {height: parseFloat(this.props.field.height)+'px'} : null;
    return (
      <FormControl id={this.props.inputId} ref={this.refFocus} fullWidth>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        {showView ? <ReactECharts option={this.props.field.bs4echart} style={style} /> : null}
      </FormControl>
    );
  }
}